import { Product } from '@/core/types/product.types';

import { BoardTypeEnum, ContentTypeEnum } from './bento-constants';

export type connectedPortalType = {
  createdBy: string;
  description: string;
  displayImage: string;
  isPasswordRequired: boolean;
  name: string;
  statusLive: boolean;
  type: string;
  _id: string;
};

export enum BoardAccessTypeEnum {
  NONE = 'NONE',

  EMAIL = 'EMAIL',

  PASSWORD = 'PASSWORD',

  MEMBERSHIP = 'MEMBERSHIP',
}

export type Board = {
  _id: string;
  name: string;
  description: string;
  type: BoardTypeEnum;
  displayImage: string;
  elements: Elements[];
  desktopUI: ElementsUI[];
  mobileUI: ElementsUI[];
  editAccess: boolean;
  accessType: BoardAccessTypeEnum;
  isPasswordRequired: boolean; // going to be deprecated
  isPortalPinned: boolean;
  password: string;
  totalElements: number;
  portalVideo: string;
  connectedBoards: Board[];
  onboardingPortal: OnBoardingPortal;
  messageOnboarding: string;
  statusLive: boolean;
  startDate: string;
  endDate: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  // vendor?: Vendor[];
  vendor?: any;
  theme?: { name: string; value: number[] };
  viewType?: BoardViewTypeEnum;
};

export type Elements = {
  _id: string;
  boardId: string;
  elementType: BoardElementTypeEnum;
  contentType: ContentTypeEnum;
  urlType: ContentUrlTypeEnum;
  content: Content;
  url: string;
  sectionText: string;
  location: Map;
  ui: UiDef;
  cardsCount: number;
  createdBy: string;
};

enum BoardElementTypeEnum {
  CONTENT = 'CONTENT',
  ASSET = 'ASSET',
  PORTAL = 'PORTAL', // board
  SECTION = 'SECTION', // deprecated
  MAP = 'MAP',
}

enum ContentUrlTypeEnum {
  BOLDER = 'BOLDER',
  THIRD_PARTY = 'THIRD_PARTY',
  SOCIAL = 'SOCIAL',
  NATIVE = 'NATIVE',
}

export enum BoardViewTypeEnum {
  STATIC = 'STATIC',
  TEXT = 'TEXT',
  GRID = 'GRID',
}

export type Content = {
  _id: string;
  content: ContentData;
  createdBy: string;
};

export type ContentData = {
  url: string;
  text: string;
  caption: string;
  href: string;
  hAlign: string;
  vAlign: string;
  bgColor: string;
  fileName: string;
  assetId: string;
  metadata?: any;
  summary?: any;
  questions?: any;
};

export type Map = {
  latitude: number;
  longitude: number;
  zoom: number;
  caption: string;
};

export type UiDef = {
  desktop: PositionSize;
  mobile: PositionSize;
};

export type PositionSize = {
  x: number;
  y: number;
  h: number;
  w: number;
  r?: number;
  z?: number;
};

export type ElementsUI = {
  elementid: string;
  x: number;
  y: number;
  h: number;
  w: number;
};

export type OnBoardingPortal = {
  _id: string;
  onboardingImage: ImageObject[];
  bgImage: string;
  boardId: string;
  usePortalVideo: boolean;
};

export type ImageObject = {
  imageUrl: string;
  caption: string;
};

export type VisitorType = {
  _id: string;
  userId: string;
  Name: string;
  Email: string;
  DisplayPic?: string;
  isActor: boolean;
  portalDropsCount: number;
  inNetwork: boolean;
  Handle?: string;
};

export enum BoardTabsEnum {
  PORTAL = 'PORTAL',
  FEED = 'FEED',
}

export type Vendor = {
  businessDescription: string;
  businessLogo: string;
  businessName: string;
  businessProfileImage: string;
  businessEmail: string;
  _id: string;
  slug: string;
};

export type Business = {
  _id: string;
  createdBy: string;
  updatedBy: string;
  isDeleted: boolean;
  tenantId: string;
  businessName: string;
  businessDescription: string;
  businessLogo: string;
  businessAddress: {
    Line1: string;
    City: string;
    State: string;
    Country: string;
    ZipCode: string;
  };
  businessProfileImage: string;
  countryCode: string;
  businessContactNumber: string;
  businessEmail: string;
  businessType: string;
  businessSocialLinks: string[];
  masterUser: {
    Name: string;
    Email: string;
    Id: string;
  };
  marketplacecategories: string[];
  currencyCode: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  status: string;
  slug: string;
  isTestModeOn: boolean;
  plan: string;
  membershipProduct?: Product[];
};
